<template>
    <div class="kit-card-total">
        <h5 class="def-header-5">{{ result.kitTitle }}</h5>
        <p class="kit-card-total__text">
            {{ result.kitDescription }}
        </p>
        <div v-if="price" class="kit-card-total__prices">
            <p class="def-price">{{ price.printPrice }}</p>
            <p class="def-price-old">{{ price.printPriceOld }}</p>
        </div>
        <p class="kit-card-total__save">{{ price.printDiscount }}</p>
        <button
            type="button"
            class="def-button"
            @click="handlerAddToBasket"
        >
            {{ messages.kitBuy }}
        </button>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ProductKitsTotal',
    props: ['kits', 'result'],
    computed: {
        ...mapState({
            messages: ({ product }) => product?.data?.product?.kits?.messages
        }),
        price() {
            return this.result.kitPrice;
        }
    },
    methods: {
        handlerAddToBasket() {
            this.$DefModal.show({
                name: 'ProductKitsModal',
                width: '790px',
                padding: false,
                props: {
                    result: this.result,
                    kits: this.kits,
                }
            });
        }
    }
}
</script>

<style lang="scss">
.kit-card-total {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    flex-shrink: 0;
    padding: 16px;
    text-align: center;
    @include point-md {
        width: 236px;
    }
    @include point-lg {
        width: 324px;
        padding: 32px;
    }

    &__text {
        font-weight: 400;
        font-size: rem(16);
        color: #757575;
        @include point-lg {
            font-size: rem(18);
        }
    }

    &__prices {
        display: flex;
        align-items: center;
        margin-top: 40px;
    }

    &__save {
        font-weight: 500;
        font-size: rem(14);
        line-height: 110%;
        color: var(--text-colour-secondary);
        margin-top: 8px;
        @include point-lg {
            font-size: rem(16);
        }
    }

    .def-price {
        font-size: rem(18);
        @include point-lg {
            font-size: rem(24);
        }

        &:not(:last-child) {
            margin-right: 14px;
            @include point-lg {
                margin-right: 16px;
            }
        }
    }

    .def-price-old {
        font-size: rem(14);
        @include point-lg {
            font-size: rem(18);
        }
    }

    .def-button {
        display: flex;
        width: 100%;
        font-weight: 500;
        font-size: rem(14);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        margin-top: 24px;
        @include point-md {
            margin-top: 48px;
        }
        @include point-lg {
            height: 56px;
            font-size: rem(18);
            margin-top: 64px;
        }
    }
}
</style>